export default __webpack_public_path__ + "static/media/aceite.482ddcde.svg";